import React from "react"



export default function Blackcheckers (){

    // const RenderBlack = () => {

    //     return(

    //         <div className="black">
    //             <div className="tile">

    //                 <div className="face">
    //                     <div className="faceblack facefront">
    //                     </div>
    //                 </div>

    //                 <div className="row">
    //                     <div className="oneblack subtile">
    //                     </div>
    //                     <div className="twoblack subtile">
    //                     </div>
    //                 </div>

    //                 <div className="row">
    //                     <div className="threeblack subtile">
    //                     </div>
    //                     <div className="fourblack subtile">
    //                     </div>
    //                 </div>

    //             </div>
    //         </div>

    //     )
    // }

    return(

        <div className="black">
            <div className="tile">

                <div className="face">
                    <div className="faceblack facefront">
                    </div>
                </div>

                <div className="row">
                    <div className="oneblack subtile">
                    </div>
                    <div className="twoblack subtile">
                    </div>
                </div>

                <div className="row">
                    <div className="threeblack subtile">
                    </div>
                    <div className="fourblack subtile">
                    </div>
                </div>


            </div>
        </div>
            
    )
}